import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useOrderlistStore } from '@/store/orderlist'

export const useGlobalStore = defineStore('global', () =>
{
    const loading = ref(false)
    const error = ref(false)
    const orderlist = useOrderlistStore()
    const showOverlay = ref(false)
    const otherOrderForAddress = ref(window.app.orderhistory.otherOrderForAddress)

    async function init ()
    {
        await orderlist.getOrderItems()
    }


    return {
        loading,
        error,
        showOverlay,
        otherOrderForAddress,
        init
    }
})
